import { FC, useState } from 'react';
import { Spinner } from '@chakra-ui/react';
import { ICON_BY_NAME } from 'ui/components/Icons/Icon';
import styles from './DragAndDropInput.module.css';
export interface DragAndDropInputProps {
  id: string;
  label?: string;
  onUpload?: (e: React.ChangeEvent<HTMLInputElement>) => void;
  loading?: boolean;
  errors?: string;
  inputRef: React.RefObject<HTMLInputElement>;
  InputProps?: React.InputHTMLAttributes<HTMLInputElement>;
}
export const DragAndDropInput: FC<DragAndDropInputProps> = ({
  id = 'attachment',
  label,
  onUpload = () => {},
  loading = false,
  errors,
  InputProps,
  inputRef
}) => {
  const [dropping, setDropping] = useState(false);
  const handleUpload = (e: React.ChangeEvent<HTMLInputElement>) => {
    onUpload(e);
  };
  const dragEnter = (event: React.DragEvent<HTMLLabelElement>) => {
    event.stopPropagation();
    event.preventDefault();
    setDropping(true);
  };
  const dragOver = (event: React.DragEvent<HTMLLabelElement>) => {
    event.stopPropagation();
    event.preventDefault();
  };
  const dragLeave = (event: React.DragEvent<HTMLLabelElement>) => {
    event.stopPropagation();
    event.preventDefault();
    setDropping(false);
  };
  const drop = (event: React.DragEvent<HTMLLabelElement>) => {
    event.stopPropagation();
    event.preventDefault();
    setDropping(false);
  };
  return <div className={`${styles.target} ${dropping ? styles.dropping : ''}`} data-sentry-component="DragAndDropInput" data-sentry-source-file="DragAndDropInput.tsx">
      <label htmlFor={id} className={styles.dragContainer} onDragEnter={dragEnter} onDragOver={dragOver} onDragLeave={dragLeave} onDrop={drop}>
        <div style={{
        pointerEvents: 'none',
        visibility: loading ? 'hidden' : 'visible'
      }}>
          {/* Placeholder icon */}
          <ICON_BY_NAME.file className={styles.icon} height="8" width="8" marginBottom="4" data-sentry-element="unknown" data-sentry-source-file="DragAndDropInput.tsx" />
          <div className={styles.label}>
            {label || 'Click to Select a File'}
          </div>
          {errors && <div className={styles.errors}>{errors}</div>}
        </div>

        {loading && <div className={styles.spinner}>
            <Spinner color="chonky.500" thickness="4px" speed="0.65s" size="xl" />
          </div>}
      </label>
      <input {...InputProps} id={id} name={id} type="file" onChange={handleUpload} className={styles.hiddenInput} ref={inputRef} />
    </div>;
};